import { serverGet } from "lib/serverRequest";
import { serverPost } from "lib/serverRequest";

export const getPiesOfMonth = ({ onFinish = () => {} }) => {
  serverGet({
    url: `pieOfMonth/getOne`,
    onFinish: onFinish,
  });
};

export const createPieOfMonth = ({ data = {}, onFinish = () => {} }) => {
  serverPost({
    url: `pieOfMonth/create`,
    data: data,
    onFinish: onFinish,
  });
};

export const updatePieOfMonth = ({ data = {}, onFinish = () => {} }) => {
  serverPost({
    url: `pieOfMonth/update`,
    data: data,
    onFinish: onFinish,
  });
};
